<template>
  <div id="recruitFaq">
    <div class="recruit__container">
      <div class="recruit__wrapper">
        <p class="recruit__title">많은 예비 전문가가 <br>궁금해 하셨어요</p>
        <div class="recruit__faq">
          <div class="faq__item" :class="{on: f.on}" v-for="(f, index) in faq" :key="index"
            @click="clickFaq(index)">
            <p class="item__front">{{f.q}}</p>
            <p class="item__back">{{f.a}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const FAQ = [
  {q: '가입비가 있나요?', a: '아니요, 가입비 등 일체의 비용이 발생하지 않습니다.', on: false},
  {q: '회당 전문가 정산비는 얼마인가요?', a: '평균 5만원대 입니다. (수업 목적·인원수에 따라 상이)', on: false},
  {q: '센터에 소속되어 있어도 괜찮나요?', a: '네, 아무런 제약 없이 겸업이 가능합니다.', on: false},
  {q: '먼 거리의 수업도 다녀야 하나요?', a: '아니요, 수업 가능 지역은 전문가님이 설정하고 활동합니다.', on: false},
  {q: '최소 활동 조건 같은게 있나요?', a: '아니요, 전문가님의 상황에 맞게 활동하실 수 있습니다.', on: false},
  {q: '활동이 어려워지면 어떻게 하나요?', a: '자유로운 프로그램 ON/OFF가 가능합니다.', on: false},
  {q: '직접 회원 영업을 하지 않아도 되나요?', a: '네, 전문가님은 수업에 보다 집중하시면 됩니다.', on: false},
  {q: '다른 플랫폼과 무엇이 다른가요?', a: '', on: false},
]
export default {
  name: 'RecruitFaq',
  data(){
    return{
      faq: FAQ,
    }
  },
  methods: {
    clickFaq(index){
      if(this.faq.length - 1 === index) {
        this.faq.forEach(f => f.on = false)
        this.$emit('open-faq-modal')
        return
      }
      const clicked = this.faq[index].on
      this.faq.forEach(f => f.on = false)
      this.faq[index].on = !clicked
    },
  }
}
</script>